// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"bb8ff6c1","466":"fdf510ac","600":"dea4a637","682":"a3aac689","787":"06b33cdf"}[chunkId] + ".chunk.js";
};